import React from 'react';
import { toast } from 'react-toastify';

import ToastCustom from '../components/toast';

function useToast() {
	function showToast({ ...props }) {
		toast(<ToastCustom {...props} />);
	}

	return { showToast };
}

export default useToast;
